
import Breadcrumbs from "~/components/UI/Breadcrumbs.vue";
import OtherEvents from "~/components/events/OtherEvents.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  components:
      {
        Swiper,
        SwiperSlide,
        OtherEvents,
        Breadcrumbs,
      },
  fetch: async function () {
    await this.getEvent();
  },
  head: function () {
    const setHead = this.setHead;
    const title = setHead?.title || "Наш опыт — перевозки грузов";
    const description = setHead?.description || `Ознакомьтесь с последними событиями и выполненными перевозками различных грузов в ${this.cityName}, России и СНГ. Осуществляются перевозки грузов транспортной компанией Central Trans по РФ с гарантией качества`;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  data() {
    return {
      event: {},

      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: 3,
        slidesPerGroup: 1,
        loop: true,
        // autoHeight: true,
        navigation: {
          prevEl: '.page-event__button-navigation--prev',
          nextEl: '.page-event__button-navigation--next',
        },
      },

      activeSlide: 0,
    }
  },

  computed: {
    eventDate: function () {
      return new Date(this.event?.created_at * 1000).toLocaleDateString('ru', {
        day: '2-digit',
        month: "long",
        year: 'numeric'
      });
    },
    cmsPageId: function () {
      return Number.parseFloat(this.event?.cms_page_id || 0)
    },
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Наши события", path: "/events" },
        { title: this.event?.title, path: this.$route.fullPath },
      ]
    },
    setHead: function () {
      const event = this.event || {};

      return {
        title: event?.seo_title,
        description: event?.seo_description,
      }
    },
    cityName: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name;
    },
  },

  methods: {
    getEvent: async function() {
      const slug = this.$route?.params?.slug;
      const eventResponse = await this.$api.agent.transport.get(`/event/${ slug }`).then((res) => {
        return res.data
      }).catch((err) => {
        return null
      });
      if (!eventResponse) {
        this.$nuxt.error({
          statusCode: 404,
          message: "Событие не найдено"
        });
        return
      }
      this.event = eventResponse || {};
      this.isUrlWithId()
    },
    openImages: function (index) {
      this.$store.commit("pop-up-images/setOpen", {
        images: (this.event.images || []).map((t) => t.image),
        activeIndex: index,
      });
    },

    // редирект через 301, т.к по id страница тоже доступна, для сео
    // ВАЖНО: путь абсолютный и с защитой от перехода на себя — раньше отдавался
    // относительный слаг, из-за чего клиент уходил на ту же страницу и попадал
    // в бесконечную перезагрузку (инцидент 29.10.2026)
    isUrlWithId: function () {
      const event = this.event;

      if (!event || !event.id || !event.slug) {
        return;
      }

      const segment = String(this.$route.path || '').split('/').filter(Boolean).pop() || '';

      if (segment !== String(event.id) || String(event.slug) === segment) {
        return;
      }

      return this.$nuxt.context.redirect(301, `/events/${event.slug}`);
    },
  },
};
